<template>
    <div class="vh-100">

        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left">
                    <div class="header-item">
                        <div class="icon-24 icon-left-blue"></div>
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Tambah Layanan Snap</div>
                <div class="header-top--right">
                    <div class="header-item">
                        <!-- <div class="icon-24 icon-search-blue"></div> -->
                    </div>
                </div>
            </div>
        </div>

        <!-- CONTENT -->
        <div class="content-wrapper main-page">
            <div class="w-limit p-t-16 p-d-20 p-x-20">

                <div class="form-group mod">
                    <label for="namalayanansnap" class="form-label require">Nama Layanan</label>
                    <input type="text" class="form-control" placeholder="Nama Layanan...">
                </div>

                <div class="m-t-16">
                    <label for="radio1" class="form-label require">Jenis Layanan</label>
                    <div class="radio-group">
                        <div class="radio-wrapper">
                            <div class="radio-item" @click="Selfserviceactive">
                                <input type="radio" id="radio1" name="radioboxx" v-model="Jenis_layanan">
                                <label for="radio1">Self Service</label>
                            </div>
                            <div class="radio-item" @click="DropOffactive">
                                <input type="radio" id="radio2" name="radioboxx" v-model="Jenis_layanan">
                                <label for="radio2">Drop Off</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="m-t-16 d-flex">
                    <div class="flex-1">
                        <label for="form1" class="form-label require">Harga</label>
                        <div class="input-group mod">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Rp</span>
                            </div>
                            <input type="text" class="form-control" placeholder="123.456" id="form1" value="800.000">
                        </div>
                    </div>
                    <div class="m-l-8">
                        <div class="form-group mod">
                            <label for="exampleFormControlSelect1" class="form-label">Per</label>
                            <select class="form-control right-icon icon-dropdown" id="exampleFormControlSelect1" v-if="Jenis_layanan===1" disabled>
                                <option>Load</option>
                            </select>
                            <select class="form-control right-icon icon-dropdown" id="exampleFormControlSelect1" v-else>
                                <option>Load</option>
                            </select>
                        </div>
                    </div>
                </div>

            </div>

            <div class="separator"></div>

            <div class="w-limit p-y-20 p-x-20">

                <div class="form-group mod">
                    <label for="form2" class="form-label require">Jenis mesin yang digunakan</label>
                    <select class="form-control right-icon icon-dropdown" id="form2" v-if="Jenis_layanan===1">
                        <option>Mesin Pengering (SnapClean)</option>
                        <option>Mesin Cuci (SnapClean)</option>
                    </select>
                    <select class="form-control right-icon icon-dropdown" id="form2" v-else>
                        <option>Mesin Pengering (SnapClean)</option>
                        <option>Mesin Cuci (SnapClean)</option>
                        <option>Mesin Reguler</option>
                    </select>
                </div>

                <div class="m-t-16 d-flex">
                    <div class="flex-1">
                        <label for="" class="form-label">Kapasitas maksimal</label>
                        <div class="input-group mod">
                            <input type="text" class="form-control" placeholder="123.456" id="form1" value="0">
                            <div class="input-group-append">
                                <span class="input-group-text">Kg</span>
                            </div>
                        </div>
                    </div>
                    <div class="flex-1 m-l-8">
                        <label for="" class="form-label">Toleransi</label>
                        <div class="input-group mod">
                            <input type="text" class="form-control" placeholder="123.456" id="form1" value="0">
                            <div class="input-group-append">
                                <span class="input-group-text">Kg</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="m-t-16">
                    <div class="d-flex align-items-end">
                        <div class="form-group mod flex-1">
                            <label for="" class="form-label">Durasi mesin bekerja</label>
                            <div class="number-counter mod">
                                <input min="0" max="23" value="0" type="number" class="form-control" id="input-1">
                                <div class="input-suffix">Jam</div>
                                <div class="counter-btn inc"></div>
                                <div class="counter-btn dec"></div>
                            </div>
                        </div>
                        <div class="form-group mod flex-1 m-l-8 m-d-0">
                            <div class="number-counter mod">
                                <input min="0" max="59" value="0" type="number" class="form-control" id="input-1">
                                <div class="input-suffix">Menit</div>
                                <div class="counter-btn inc"></div>
                                <div class="counter-btn dec"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="m-t-16" id="Durasi_Pengerjaan">
                    <div class="d-flex align-items-end">
                        <div class="form-group mod flex-1">
                            <label for="" class="form-label">Durasi Pengerjaan</label>
                            <div class="number-counter mod">
                                <input min="0" max="99" value="0" type="number" class="form-control" id="input-1">
                                <div class="input-suffix">Hari</div>
                                <div class="counter-btn inc"></div>
                                <div class="counter-btn dec"></div>
                            </div>
                        </div>
                        <div class="form-group mod flex-1 m-l-8 m-d-0">
                            <div class="number-counter mod">
                                <input min="0" max="23" value="0" type="number" class="form-control" id="input-2">
                                <div class="input-suffix">Jam</div>
                                <div class="counter-btn inc"></div>
                                <div class="counter-btn dec"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="m-t-16 mod">
                    <label class="form-label require">Kategori Mesin</label>
                    <Select2 class="test-select fl-is-required inputs" id="select2"
                        :settings="{ placeholder: 'Pilih kategori mesin' }" />
                </div>

                <div class="m-t-16 mod">
                    <label class="form-label">Kategori Layanan</label>
                    <Select2 class="test-select fl-is-required inputs" id="select22"
                        :settings="{ placeholder: 'Ketuk untuk menambah' }" />
                </div>

            </div>

            <div class="separator"></div>

            <div class="w-limit p-t-24 p-d-20 p-x-20">
                <button class="btn smart-secondary">Simpan & tambah lainnya</button>
                <button class="btn smart-primary m-t-12">Simpan</button>
            </div>

        </div>

    </div>
</template>

<script>
    import Select2 from 'v-select2-component';
    export default {
        components: {
            Select2
        },
        data(){
            return{
                Jenis_layanan:1,
            }
        },
        mounted() {
            this.inputCalc();
            this.Selfserviceactive();
        },
        methods: {

            Selfserviceactive(){
                var value = $("input[name=radioboxx]:checked").val();
                this.Jenis_layanan = 1;
                $("#radio1").prop("checked", true);
                $("#radio2").prop("checked", false);
                $('#Durasi_Pengerjaan').hide();
                // this.Cekvalidasicicil();
            },

            DropOffactive(){
                var value = $("input[name=radioboxx]:checked").val();
                this.Jenis_layanan = 2;
                $("#radio1").prop("checked", false);
                $("#radio2").prop("checked", true);
                $('#Durasi_Pengerjaan').show();
                // this.Cekvalidasicicil();
            },

            inputCalc() {
                $('.number-counter').each(function (i, obj) {

                    var inputx = $(this).children('input');
                    var increment = $(this).children('.inc');
                    var decrement = $(this).children('.dec');
                    var suffix = $(this).children('.input-suffix');
                    var suffixWidth = suffix.width();

                    // suffix positioning
                    suffix.css('left', "calc(50% - (" + suffixWidth + "px / 3) + 3px)");
                    suffix.prev().css('padding-right', 'calc(50% + (' + suffixWidth + 'px / 3))');

                    // select all if click
                    inputx.click(function () {
                        $(this).select()
                    });

                    // input limit
                    inputx.on('input', function () {
                        var value = $(this).val();
                        if ((value !== '') && (value.indexOf('.') === -1)) {
                            $(this).val(Math.max(Math.min(value, $(this).attr('max')), $(this).attr('min')));
                        }
                        if (value == '') {
                            $(this).val($(this).attr('min'));
                        }
                    });

                    // increment button
                    increment.click(function(){
                        var inputz = $(this).siblings('input');
                        if (inputz.val() < parseInt(inputz.attr('max'))){
                            inputz.val(parseInt(inputz.val())+1)
                        }
                    });

                    // decrement button
                    decrement.click(function(){
                        var inputz = $(this).siblings('input');
                        if (inputz.val() > parseInt(inputz.attr('min'))){
                            inputz.val(parseInt(inputz.val())-1)
                        }
                    });
                })
            }
        }
    }
</script>

<style>

</style>